"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("./datapoints");
var removeInboxRuleService_1 = require("../services/removeInboxRuleService");
var store_1 = require("../store/store");
var owa_analytics_1 = require("owa-analytics");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Removes the given rule
 * @param inboxRuleId the inbox rule id
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default.inboxRulesListState; },
})(legacy_1.action('removeInboxRule', datapoints_1.default.removeInboxRuleDatapoint)(function removeInboxRule(inboxRuleId, state) {
    var dataPoint = owa_analytics_1.returnTopExecutingActionDatapoint();
    var optionState = state.optionState;
    var inboxRule = optionState.inboxRules.get(inboxRuleId);
    optionState.inboxRules.delete(inboxRuleId);
    optionState.inboxRuleIds.splice(optionState.inboxRuleIds.indexOf(inboxRuleId), 1);
    // TODO: Task 20143: Full error handling / success notification support
    return removeInboxRuleService_1.default(inboxRule)
        .then(function (response) {
        if (!response.WasSuccessful) {
            var errorMessage = response.ErrorMessage
                ? response.ErrorMessage
                : 'Response WasSuccessful was false';
            dataPoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, new Error(errorMessage));
        }
    })
        .catch(function (error) {
        dataPoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, error.message);
    });
}));
//# sourceMappingURL=removeInboxRule.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/removeInboxRule.js
// module id = 5171
// module chunks = 2